import React from "react";
import { Row, Col, Form, Modal, Descriptions, Input, notification } from "antd";
import { ExclamationCircleOutlined, PlusOutlined, CloseOutlined } from "@ant-design/icons";

import api from "../../../services/api";
import { getLocal } from "../../../services/auth";
import { HasValue } from "../../../services/funcoes";
import apiPayer from "../../../services/apiPayer";

export default function ModalCancelarVenda({ detalhesNF, exibirModalCancelarVenda, fecharModalCancelarVenda, atualizaLista, setAtualizaLista }) {

    const [form] = Form.useForm();

    const onCloseModal = () => {
        Modal.confirm({
            title: 'Cancelar?',
            icon: <ExclamationCircleOutlined />,
            content: 'Deseja cancelar a operação?',
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            onOk() {
                fecharModalCancelarVenda();
            }
        });
    };

    const inutilizarNota = async () => {
        let dados = { ...detalhesNF };
        let mensagemCancelamento = '';
        dados.loc_id = parseInt(getLocal());
        dados.justificativa = form.getFieldValue().justificativaCancelamento;
        if (!dados.justificativa || dados.justificativa.length < 15) {
            notification.warning({ message: 'Aviso!', description: 'A Justificativa deve ter no minimo 15 caracteres!' });
            return false;
        }
        try {
            const res = await api.post(`NotaFiscal/Cancelar`, dados);
            if (!!res.data && !!res.data.retorno.retEvento && !!res.data.retorno.retEvento.length > 0) {
                mensagemCancelamento = res.data.retorno.retEvento[0].infEvento.cStat + '-' + res.data.retorno.retEvento[0].infEvento.xMotivo;
                if (res.data.retorno.retEvento[0].infEvento.cStat === 135 || res.data.retorno.retEvento[0].infEvento.cStat === 101) {
                    await verificarEstornoPagamentoEletronico(dados); // Aguarda antes de continuar
                    notification.success({ message: `NF-e Nº: ${detalhesNF.ntf_numero} Cancelada com sucesso!` });
                } else {
                    notification.warning({ message: `Não foi possível efetuar o cancelamento da NF-e Nº: ${detalhesNF.ntf_numero} !`, description: mensagemCancelamento });
                }
            } else if (!!res.data) {
                notification.success({ message: `NF-e Nº: ${detalhesNF.ntf_numero} cancelada com sucesso!` });
            }
        } catch (erro) {
            if (erro.response.data)
                notification.warning({ description: `Não foi possível efetuar o cancelamento do Doc. Fiscal Nº: ${detalhesNF.ntf_numero},  ${erro.response.data} !`, message: 'Aviso' });
            else
                notification.warning({ description: `Não foi possível cancelar a NF-e Nº: ${detalhesNF.ntf_numero} !`, message: 'Aviso' });
            console.error("Erro ao cancelar:", erro);
        }
        finally {
            form.resetFields();
            setAtualizaLista(true);
            fecharModalCancelarVenda();
        }
    }

    async function verificarEstornoPagamentoEletronico(dados) {
        if (dados.ntf_status == 1) {
            let formaPagIntegrado = dados.formasPgto.filter((item) => HasValue(item.imp_autorizacao));
            if (formaPagIntegrado.length > 0) {
                await modalEstornarPagtos(formaPagIntegrado); // Aguarda a interação do modal
            }
        }
    }

    function modalEstornarPagtos(pagamentos) {
        const descricoesConcatenadas = pagamentos
            .map((item) => item.fpg_descricao)
            .join(', ');

        return new Promise((resolve, reject) => {
            Modal.confirm({
                title: 'Atenção',
                icon: <ExclamationCircleOutlined />,
                content: (
                    <>
                        Esta nota possui pagamentos integrados com as seguintes formas de pagamento:
                        <br />
                        <strong>{descricoesConcatenadas}</strong>.
                        <br />
                        Deseja estorná-los?
                        <br />
                        Pode ser necessário o uso do cartão para concluir o processo.
                    </>
                ),
                okText: 'Sim',
                cancelText: 'Não',
                onOk: async () => {
                    console.log("Estorno confirmado.");
                    await verificarPagamentos(pagamentos); // Aguarda os estornos antes de concluir
                    resolve();
                },
                onCancel: () => {
                    console.log("Estorno cancelado.");
                    resolve();
                    //reject();
                },
            });
        });
    }

    async function verificarPagamentos(pagamentos) {
        for (const item of pagamentos) {
            if (item.fpg_tipointegracao != null) {
                try {
                    if (item.fpg_tipointegracao == 1) {
                        // Integração Vero
                        console.log("Estorno via Vero ainda não implementado.");
                    }
                    else if (item.fpg_tipointegracao == 2) {
                        // Payer localhost
                        const dadosIntegracaoPos = {
                            command: "CANCELLMENT",
                            idPayer: item.imp_idintegracao,
                        };
                        const retorno = await apiPayer.post('Client/Request', dadosIntegracaoPos);
                        console.log("Estorno Payer localhost concluído:", retorno);
                    }
                    else if (item.fpg_tipointegracao == 4) {
                        // Payer Gateway
                        const retorno = await api.post(`Payer/IncluirCancellmentPayerRequest/${item.imp_idintegracao}`);
                        console.log("Estorno Payer Gateway concluído:", retorno.data);
                    }
                } catch (error) {
                    notification.warning({
                        description: `Falha ao estornar a integração do pagamento ${item.fpg_descricao}. Detalhes: ${error.message}`,
                        message: 'AVISO!',
                    });
                    console.error("Erro ao processar pagamento:", error);
                }
            }
        }
    }

    return (
        <Modal centered
            title="Cancelamento da Venda"
            open={exibirModalCancelarVenda}
            getContainer={false}
            onCancel={onCloseModal}
            onOk={() => inutilizarNota()}
            okText={
                <>
                    <PlusOutlined /> Salvar
                </>
            }
            cancelText={
                <>
                    <CloseOutlined /> Cancelar
                </>
            }
            maskClosable={false}
            width={720}
        >
            <Descriptions size="small">
                <Descriptions.Item label="Número do Cupom">
                    <b> {detalhesNF.ntf_numero} </b>
                </Descriptions.Item>
                <Descriptions.Item label="Série">
                    <b> {detalhesNF.ntf_serie} - {detalhesNF.ser_serie} </b>
                </Descriptions.Item>
            </Descriptions>
            <Form layout="vertical" name="manutencaoCancelamentoVenda" form={form}>
                <Row>
                    <Col span={24}>
                        <Form.Item label="Justificativa" name="justificativaCancelamento">
                            <Input.TextArea placeholder="Informe a Justificativa" />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}